/** fallback no op strategy */
var noOp = function () { };
var noOpNull = function () { return null; };
var noOpEmptyObject = function () { return ({}); };
var noOpStorage = {
    getAllItems: noOpEmptyObject,
    getItem: noOpNull,
    setItem: noOp,
    removeItem: noOp,
    clear: noOp,
    get length() {
        return 0;
    },
};
export var noOpStrategy = {
    name: 'noOpStrategy',
    isSupported: function () { return true; },
    storageInstance: function () { return noOpStorage; },
};
